import { apiClient } from './client'
import type { ArticleSummary } from '@/types/content'

export type RecommendationMode = 'default' | 'keep_learning' | 'surprise'

export interface RecommendationExplanation {
  reasonCode: string
  reasonText: string
  matchedWords: string[]
  dueWordCount: number
}

export interface RecommendedArticle {
  article: ArticleSummary
  reasons: string[]
  estimatedMinutes: number
  overlapDueWordCount: number
  confidenceScore: number
  explanations: RecommendationExplanation[]
}

export const readingApi = {
  getRecommended: (mode: RecommendationMode = 'default', maxMinutes?: number) => {
    const params: Record<string, string | number> = {}
    if (mode !== 'default') {
      params.mode = mode
    }
    if (maxMinutes != null) {
      params.maxMinutes = maxMinutes
    }
    return apiClient.get<RecommendedArticle>('/reading/recommended', { params }).then((r) => r.data)
  },
}
